<p *ngIf="message">
  {{ message }}
</p>

<p *ngIf="errorMessage">
  {{ errorMessage | translate }}
</p>
